export default "/wp-content/plugins/pottsalat/assets/js/components/Topbar/greenclub-text.svg";